import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a6e593b8")

_pushScopeId("data-v-a6e593b8")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" アカウント招待 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "招待アカウント", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("招待email")
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", null, "アクセス権", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", null, "予約受付", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("患者の診察、カルテの記入を行うアカウントはチェックしてください。")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("予約受付")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("アカウントを招待する")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("この設定でアカウントを招待しますか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_validate_edit_box = _resolveComponent("validate-edit-box")
  const _component_radio_button_group = _resolveComponent("radio-button-group")
  const _component_alert_message = _resolveComponent("alert-message")
  const _component_description = _resolveComponent("description")
  const _component_toggle_switch = _resolveComponent("toggle-switch")
  const _component_vue_content_item_frame = _resolveComponent("vue-content-item-frame")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content, null, {
        default: _withId(() => [
          _hoisted_2,
          _createVNode(_component_validate_edit_box, {
            class: "vue-content-edit-box",
            title: "招待メール",
            placeholder: "招待する人のemailアドレス",
            required: true,
            validation: _ctx.submitted ? _ctx.emailError : undefined,
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["validation", "modelValue"]),
          _hoisted_4,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.radioButtonGroups, (radioButtonGroup) => {
            return (_openBlock(), _createBlock(_component_radio_button_group, {
              key: 'radio-group-'+radioButtonGroup.groupId,
              "group-id": radioButtonGroup.groupId,
              radios: radioButtonGroup.group,
              modelValue: _ctx.selectedPermissions[radioButtonGroup.groupId],
              "onUpdate:modelValue": ($event: any) => (_ctx.selectedPermissions[radioButtonGroup.groupId] = $event)
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(radioButtonGroup.title), 1)
              ]),
              _: 2
            }, 1032, ["group-id", "radios", "modelValue", "onUpdate:modelValue"]))
          }), 128)),
          (_ctx.permissionError)
            ? (_openBlock(), _createBlock(_component_alert_message, { key: 0 }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.permissionError), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_5,
          _createVNode(_component_vue_content_item_frame, null, {
            default: _withId(() => [
              _createVNode(_component_description, null, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_toggle_switch, {
                modelValue: _ctx.acceptAppointment,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.acceptAppointment = $event))
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_normal_button, {
            class: "submit-button",
            state: "normal",
            disabled: _ctx.requesting,
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})